import { useCallback, useEffect, useState } from "react"

import {
  fetchProviderSettings,
  testProviderConnection,
  updateProviderSettings,
} from "src/features/integrations/api/providersApi"

// Loads + mutates one provider's settings (exotel / msg91 / springedge).
// Same hand-rolled load/mutate shape as useGupshupSettings.
export function useProviderSettings(provider) {
  const [config, setConfig] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [isTesting, setIsTesting] = useState(false)

  const load = useCallback(async () => {
    setIsLoading(true)
    try {
      setConfig(await fetchProviderSettings(provider))
    } finally {
      setIsLoading(false)
    }
  }, [provider])

  useEffect(() => {
    load()
  }, [load])

  const save = useCallback(async (payload) => {
    setIsSaving(true)
    try {
      const next = await updateProviderSettings(provider, payload)
      setConfig(next)
      return next
    } finally {
      setIsSaving(false)
    }
  }, [provider])

  const test = useCallback(async (toAddress) => {
    setIsTesting(true)
    try {
      return await testProviderConnection(provider, toAddress)
    } finally {
      setIsTesting(false)
    }
  }, [provider])

  return { config, isLoading, isSaving, isTesting, save, test, reload: load }
}
